/**
 * Created by bjarne on 2017-03-24.
 */
module com.quickspin.module.api {

	export interface IModuleServices {

		hasService(id:string):boolean;

		addService(id:string, service:any):void;

		getService(id:string):any;
	}
}